import {ErrorWithRetry} from '@github-ui/error-with-retry'

import {ERRORS} from '../constants/errors'
import styles from './CouldNotFindFallbackError.module.css'

export const CouldNotFindFallbackError = ({retry}: {retry: () => void}) => (
  <ErrorWithRetry message={ERRORS.couldNotLoad} retry={retry} className={styles.CouldNotFindFallbackErrorContainer} />
)
